import React from "react";
import { Route, Redirect } from "react-router-dom";

const AdminRoute = ({ user, component: Comp, ...rest }) => {
  return (
    <Route
      {...rest}
      component={(props) => {
        return user === "Admin" ? (
          <Comp {...props} user={user} />
        ) : (
          <Redirect to="/" />
        );
      }}
    />
  );
};

export default AdminRoute;
